import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["name", "control", "rules", "defaultValue", "containerClassName"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef, useState } from 'react';
import { Switch } from '@headlessui/react';
import { Box, FormHelperText } from '@mui/material';
import clsx from 'clsx';
import { useController } from 'react-hook-form';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
var JoveSwitch = /*#__PURE__*/forwardRef(function (props, ref) {
  var className = props.className,
      value = props.value,
      defaultChecked = props.defaultChecked,
      onChange = props.onChange,
      valueChange = props.valueChange,
      disabled = props.disabled,
      leftLabel = props.leftLabel,
      label = props.label,
      children = props.children,
      error = props.error,
      errMessage = props.errMessage,
      labelClassName = props.labelClassName;

  var _useState = useState(defaultChecked),
      checkedValue = _useState[0],
      setCheckedValue = _useState[1];
  /**
   * methods
   */


  var checkedChangeAction = function checkedChangeAction(value) {
    onChange === null || onChange === void 0 ? void 0 : onChange(value);
    setCheckedValue(value);
    valueChange === null || valueChange === void 0 ? void 0 : valueChange(value);
  };

  var realChecked = value === undefined ? checkedValue : Boolean(value);
  return /*#__PURE__*/_jsxs("div", {
    className: clsx('flex flex-col', className),
    children: [/*#__PURE__*/_jsxs(Switch.Group, {
      as: "div",
      className: "flex flex-shrink-0 items-center",
      children: [leftLabel && /*#__PURE__*/_jsx(Switch.Label, {
        as: "span",
        children: /*#__PURE__*/_jsxs("span", {
          className: "text-black-secondary mr-3 text-sm font-bold",
          children: [realChecked, leftLabel]
        })
      }), /*#__PURE__*/_jsx(Switch, {
        disabled: disabled,
        checked: realChecked,
        onChange: checkedChangeAction,
        className: clsx('mr-3 flex h-6 w-11 items-center rounded-full px-1', realChecked ? 'justify-end bg-[#0e35d1]' : 'justify-start bg-[#e5e7eb]', disabled ? 'cursor-not-allowed opacity-50' : ''),
        children: /*#__PURE__*/_jsx("span", {
          className: "h-4 w-4 rounded-full bg-white"
        })
      }), children ? children : label ? /*#__PURE__*/_jsx(Switch.Label, {
        as: "span",
        className: clsx(labelClassName || 'flex-1'),
        children: /*#__PURE__*/_jsx("span", {
          className: "text-black-secondary text-sm font-bold",
          children: label
        })
      }) : null]
    }), error && /*#__PURE__*/_jsx(FormHelperText, {
      error: error,
      children: errMessage
    })]
  });
});
export var JoveSwitchControlled = /*#__PURE__*/forwardRef(function (props, ref) {
  var name = props.name,
      control = props.control,
      rules = props.rules,
      defaultValue = props.defaultValue,
      containerClassName = props.containerClassName,
      rest = _objectWithoutProperties(props, _excluded);

  var _useController = useController({
    name: name,
    control: control,
    rules: rules,
    defaultValue: defaultValue
  }),
      _useController$field = _useController.field,
      value = _useController$field.value,
      onChange = _useController$field.onChange,
      error = _useController.fieldState.error;

  return /*#__PURE__*/_jsx(Box, {
    className: clsx('flex flex-col', containerClassName),
    children: /*#__PURE__*/_jsx(JoveSwitch, _objectSpread(_objectSpread({}, rest), {}, {
      ref: ref,
      value: value,
      defaultChecked: defaultValue,
      onChange: onChange,
      error: !!error,
      errMessage: error === null || error === void 0 ? void 0 : error.message
    }))
  });
});
export default JoveSwitch;